var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscoverChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 82,
    viewBox: "0 0 40 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8616_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5892 2.37303L35.1236 27.1359C38.2534 30.7354 40 35.5219 40 40.5C40 45.4781 38.2534 50.2646 35.1235 53.8641L12.5892 78.627C11.2062 80.1464 9.33042 81 7.37457 81C5.41871 81 3.54296 80.1464 2.15996 78.627C0.776961 77.1075 -3.55447e-06 75.0467 -3.46054e-06 72.8979C-3.36662e-06 70.7491 0.776961 68.6883 2.15996 67.1689L24.6992 42.4061C25.1599 41.8998 25.4187 41.2132 25.4187 40.4973C25.4187 39.7814 25.1599 39.0948 24.6992 38.5885L2.15996 13.8311C0.776963 12.3117 -7.36727e-07 10.2509 -6.28228e-07 8.10207C-5.19728e-07 5.95327 0.776964 3.89247 2.15996 2.37303C3.54296 0.853598 5.41871 -1.49559e-06 7.37457 -1.4261e-06C9.33043 -1.35662e-06 11.2062 0.853599 12.5892 2.37303Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8616_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverChevron);
export default __webpack_public_path__ + "static/media/discover-chevron.c011dc55570761411edb419cb96caabd.svg";
export { ForwardRef as ReactComponent };